import {
  Autocomplete, Box, Checkbox, Dialog, FormControlLabel, FormGroup, IconButton, Table,
  TableBody, TableCell, TableHead, TableRow, TextField,
  Tooltip, Accordion, AccordionSummary, AccordionDetails,
  Typography
} from '@mui/material'
import React, { useEffect, useState } from 'react'
import ToastMsg from '../../../../Components/ToastMsg/ToastMsg'
import ShowComponents from '../../DoctorNotes/Common/ShowComponent'
import { COMMON_STYLE, DIOPTER_OPTIONS, MM_OPTIONS } from '../../../../Utility/Constants'
import RestAPIService from '../../../../Utility/Services/RestAPIService'
import { Serviceurls } from '../../../../Utility/API/Serviceurls'
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import VisibilityIcon from '@mui/icons-material/Visibility';
import CloseIcon from '@mui/icons-material/Close';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

const UmaKeratometry = React.forwardRef((props, ref) => {
  const [kerato, setKerato] = useState({
    keratomentryData: [],
    diopterData: DIOPTER_OPTIONS,
    mmData: MM_OPTIONS,
    miresNotLE: false,
    miresNotRE: false,
    keratoComments: '',
    dupKeratoComments: '',
    dupKeratomentryData: '[]',
    prevKeratoComments: '',
    prevKeratomentryData: [],
    enableCompare: false,
    enableCopy: false,
    openComparePopup: false
  })
  const [message, setMessage] = useState({
    isErrorMsgText: '',
    successMsgText: '',
    isErrorMsg: false,
    successMsg: false,
  })

  React.useImperativeHandle(ref, () => ({
    performKeratometryAction: () => {
      if (JSON.stringify(kerato.keratomentryData) !== kerato.dupKeratomentryData || kerato.dupKeratoComments !== JSON.stringify(kerato.keratoComments)) {
        postKeratometryData()
      }
    }
  }))

  const errorMessage = (message) => {
    setMessage({
      ...message,
      isErrorMsg: true,
      isErrorMsgText: `${message} - KERATOMETRY`,
    })
  }

  const successMessage = (message) => {
    setMessage({
      ...message,
      successMsg: true,
      successMsgText: `${message} - KERATOMETRY`,
    })
  }

  const msgClose = () => {
    setMessage({
      ...message,
      isErrorMsg: false,
      isErrorMsgText: '',
      successMsg: false,
      successMsgText: ''
    })
  }

  const apicalls = async () => {
    await getKeratometryData()
    await getPrevKeratometryData()
  }

  useEffect(() => {
    if (kerato.prevKeratomentryData && kerato.keratomentryData) {
      let copy = kerato.prevKeratomentryData?.length > 0 ? kerato.prevKeratomentryData?.some(item => (item?.k1_value !== '' || item?.k2_value !== '' || item?.average_value !== '' || item?.cylindrical_value !== '')) : false
      let view = kerato.keratomentryData?.length > 0 ? kerato.keratomentryData?.some(item => (item?.k1_value !== '' || item?.k2_value !== '' || item?.average_value !== '' || item?.cylindrical_value !== '')) : false
      setKerato((prev) => ({
        ...prev,
        enableCopy: copy,
        enableCompare: view
      }))
    }
  }, [kerato.prevKeratomentryData, kerato.keratomentryData])
  
  useEffect(() => {
     const hasKeratoData = kerato?.keratomentryData?.some(item =>
    item.k1_value?.trim() ||
    item.k2_value?.trim() ||
    item.average_value?.trim() ||
    item.cylindrical_value?.trim()
  );
    props.setAccordionOpen((hasKeratoData || kerato?.keratoComments?.trim()) ? true : false);
  }, [kerato?.keratomentryData, kerato?.keratoComments])

  const getKeratometryData = async () => {
    try {
      const response = await RestAPIService.getAll(Serviceurls.NEW_DOC_NOTES_KERATOMENTRY + '?appointment_id=' + props?.props?.appointment_id + '&doctor_id=' + props?.props?.doctorID)

      if (response?.data?.status === 'success') {
        let ketoData = Object.keys(response?.data?.data)?.length > 0 ? response?.data?.data : {}
        let ketoArray = [
          { label: 'Dioptre - RE', k1_value: '', k2_value: '', average_value: '', cylindrical_value: '', eye_type: 'RE' },
          { label: 'MM - RE', k1_value: '', k2_value: '', average_value: '', cylindrical_value: '', eye_type: 'RE' },
          { label: 'Dioptre - LE', k1_value: '', k2_value: '', average_value: '', cylindrical_value: '', eye_type: 'LE' },
          { label: 'MM - LE', k1_value: '', k2_value: '', average_value: '', cylindrical_value: '', eye_type: 'LE' }
        ]
        setKerato((prev) => ({
          ...prev,
          keratomentryData: Object.keys(ketoData)?.length > 0 ? ketoData?.keratomentry : ketoArray,
          keratoComments: Object.keys(ketoData)?.length > 0 ? ketoData?.comments : '',
          dupKeratomentryData: Object.keys(ketoData)?.length > 0 ? JSON.stringify(ketoData?.keratomentry) : JSON.stringify(ketoArray),
          dupKeratoComments: Object.keys(ketoData)?.length > 0 ? JSON.stringify(ketoData?.comments) : JSON.stringify(''),
        }))
      }
    } catch (error) {
      if (error?.response?.data?.message) {
        errorMessage(error.response.data.message)
      } else {
        errorMessage(error.message)
      }
    }
  }

  const getPrevKeratometryData = async () => {
    try {
      const response = await RestAPIService.getAll(Serviceurls.NEW_DOC_NOTES_KERATOMENTRY_COPY +
        '?appointment_id=' + props?.props?.appointment_id + '&patient_id=' + props?.props?.patient_id + '&doctor_id=' + props?.props?.doctorID
      )
      if (response?.data?.status === 'success') {
        let ketoData = Object.keys(response?.data?.data)?.length > 0 ? response?.data?.data : {}
        setKerato((prev) => ({
          ...prev,
          prevKeratomentryData: Object.keys(ketoData)?.length > 0 ? ketoData?.keratomentry : [],
          prevKeratoComments: Object.keys(ketoData)?.length > 0 ? ketoData?.comments : '',
        }))
      }
    } catch (error) {
      if (error?.response?.data?.message) {
        errorMessage(error.response.data.message)
      } else {
        errorMessage(error.message)
      }
    }
  }

  const postKeratometryData = async () => {
    try {
      let data = {
        appointment_id: props?.props?.appointment_id,
        keratomentry: kerato.keratomentryData,
        comments: kerato.keratoComments
      }
      const response = await RestAPIService.create(data, Serviceurls.NEW_DOC_NOTES_KERATOMENTRY)

      if (response?.data?.status === 'success') {
        successMessage(response?.data?.message)
        setKerato((prev) => ({ ...prev, miresNotLE: false, miresNotRE: false }))
        await getKeratometryData()
      }
    } catch (error) {
      if (error?.response?.data?.message) {
        errorMessage(error.response.data.message)
      } else {
        errorMessage(error.message)
      }
    }
  }

  const handleChange = (index, names, value = "") => {
    const keratomentryData = [...kerato.keratomentryData]
    keratomentryData[index] = { ...keratomentryData[index], [names]: value }
    setKerato((prev) => ({ ...prev, keratomentryData }))
  }

  const autocompleteTextBox = (names, values, options = [], index, label) => {
    try {
      return (
        <Autocomplete
          disabled={props?.props?.patient_transfered || props?.props?.isLocked}
          clearIcon
          size='small'
          sx={{ width: '7dvw' }}
          value={values ?? ""}
          freeSolo={label?.includes('Dioptre') && names !== "cylindrical_value"}
          options={options}
          getOptionLabel={(option) => typeof (option) === 'string' ? option : option?.label || ''}
          onChange={(e, newValue) => { handleChange(index, names, newValue?.value) }}
          onInputChange={
            (label?.includes('Dioptre') && names !== "cylindrical_value")
              ? (event, newValue) => handleChange(index, names, newValue)
              : undefined
          }
          renderInput={(params) => (
            <TextField
              {...params}
              inputProps={{ ...params.inputProps, maxLength: 10 }}
              InputProps={{
                ...params.InputProps, emed_tid: names,
                style: { height: COMMON_STYLE.HEIGHT, padding: COMMON_STYLE.PADDING }
              }}
            />
          )}
        />
      )
    } catch (error) {
      errorMessage(error.message)
    }
  }

  const renderComparePopup = () => {
    try {
      return (
        <Dialog open={kerato.openComparePopup} maxWidth="md" fullWidth>
          <Box className='doc_addendum_popup'>
            <Box component={'div'} p={'0.2rem 0.5rem'} display={'flex'} justifyContent={'space-between'} alignItems={'center'} borderBottom={'2px solid lightgray'}>
              <Typography className='doc_notes_header_card_font'>Compare Keratometry</Typography>
              <IconButton emed_tid='cmp_prev_cls'
                onClick={() => setKerato((prev) => ({ ...prev, openComparePopup: false }))}><CloseIcon /></IconButton>
            </Box>
            <Box component={'div'} p={'0.5rem'}>
              <Box component={'div'} display={'flex'} alignItems={'center'}>
                <Typography className='doc_notes_header_card_font'>Current Keratometry</Typography>
                <Tooltip placement='top' arrow title={'Copy'}>
                  <IconButton className='Common_Btn_Min_Width' sx={{ height: '3dvh' }} emed_tid='prev_cmp_cpy'
                    onClick={() => {
                      setKerato((prev) => ({
                        ...prev,
                        keratomentryData: kerato.prevKeratomentryData,
                        keratoComments: kerato.prevKeratoComments,
                        openComparePopup: false
                      }))
                    }}
                  ><ContentCopyIcon color={'primary'} /></IconButton></Tooltip>
              </Box>
              <Box component={'div'} border={'1px solid lightgray'} mt={'0.5rem'}>
                <Table size='small'>
                  <TableHead>
                    <TableRow>
                      <TableCell className='doc_notes_tbl_header'>Eye</TableCell>
                      <TableCell className='doc_notes_tbl_header'>K1</TableCell>
                      <TableCell className='doc_notes_tbl_header'>K2</TableCell>
                      <TableCell className='doc_notes_tbl_header'>Average</TableCell>
                      <TableCell className='doc_notes_tbl_header'>Cylindrical</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {kerato.prevKeratomentryData?.map((item, index) => {
                      return (
                        <TableRow key={index}>
                          <TableCell className='doc_notes_tbl_body_cell'>{item?.label}</TableCell>
                          <TableCell className='doc_notes_tbl_body_cell'>{item?.k1_value}</TableCell>
                          <TableCell className='doc_notes_tbl_body_cell'>{item?.k2_value}</TableCell>
                          <TableCell className='doc_notes_tbl_body_cell'>{item?.average_value}</TableCell>
                          <TableCell className='doc_notes_tbl_body_cell'>{item?.cylindrical_value}</TableCell>
                        </TableRow>
                      )
                    })}
                  </TableBody>
                </Table>
              </Box>
            </Box>
            <Box component={'div'} p={'0.5rem'}>
              <Typography className='doc_notes_header_card_font'>New Keratometry</Typography>
              <Box component={'div'} border={'1px solid lightgray'} mt={'0.5rem'}>
                <Table size='small'>
                  <TableHead>
                    <TableRow>
                      <TableCell className='doc_notes_tbl_header'>Eye</TableCell>
                      <TableCell className='doc_notes_tbl_header'>K1</TableCell>
                      <TableCell className='doc_notes_tbl_header'>K2</TableCell>
                      <TableCell className='doc_notes_tbl_header'>Average</TableCell>
                      <TableCell className='doc_notes_tbl_header'>Cylindrical</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {kerato.keratomentryData?.map((item, index) => {
                      return (
                        <TableRow key={index}>
                          <TableCell className='doc_notes_tbl_body_cell'>{item?.label}</TableCell>
                          <TableCell className='doc_notes_tbl_body_cell'>{item?.k1_value}</TableCell>
                          <TableCell className='doc_notes_tbl_body_cell'>{item?.k2_value}</TableCell>
                          <TableCell className='doc_notes_tbl_body_cell'>{item?.average_value}</TableCell>
                          <TableCell className='doc_notes_tbl_body_cell'>{item?.cylindrical_value}</TableCell>
                        </TableRow>
                      )
                    })}
                  </TableBody>
                </Table>
              </Box>
            </Box>
          </Box>
        </Dialog >
      )
    } catch (error) {
      errorMessage(error.message)
    }
  }

  const renderKeratoTable = () => {
    try {
      return (
        <Box component={'div'} border={'1px solid lightgray'}>
          <Table size='small'>
            <TableHead>
              <TableRow>
                <TableCell className='doc_notes_tbl_header'>Eye</TableCell>
                <TableCell className='doc_notes_tbl_header'>K1</TableCell>
                <TableCell className='doc_notes_tbl_header'>K2</TableCell>
                <TableCell className='doc_notes_tbl_header'>Average</TableCell>
                <TableCell className='doc_notes_tbl_header'>Cylindrical</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {kerato.keratomentryData?.length > 0 ? kerato.keratomentryData?.map((item, index) => {
                let dataList = item.label?.includes('Dioptre') ? kerato?.diopterData : kerato?.mmData
                return (
                  <TableRow key={index}>
                    <TableCell className='doc_notes_tbl_body_cell doc_notes_header_card_font'>{item?.label}</TableCell>
                    <TableCell className='doc_notes_tbl_body_cell'>
                      {autocompleteTextBox('k1_value', item?.k1_value, dataList, index, item?.label)}
                    </TableCell>
                    <TableCell className='doc_notes_tbl_body_cell'>
                      {autocompleteTextBox('k2_value', item?.k2_value, dataList, index, item?.label)}
                    </TableCell>
                    <TableCell className='doc_notes_tbl_body_cell'>
                      {autocompleteTextBox('average_value', item?.average_value, dataList, index, item?.label)}
                    </TableCell>
                    <TableCell className='doc_notes_tbl_body_cell'>
                      {autocompleteTextBox('cylindrical_value', item?.cylindrical_value, dataList, index, item?.label)}
                    </TableCell>
                  </TableRow>
                )
              }) : <TableRow><TableCell align='center' colSpan={5}>{COMMON_STYLE.NO_RECORDS}</TableCell></TableRow>}
            </TableBody>
          </Table>
        </Box>
      )
    } catch (error) {
      errorMessage(error.message)
    }
  }

  const onChangeCheckboxHandler = (e, key) => {
    try {
      let value = e.target.checked;

      setKerato((prev) => {
        let updatedKeratomentryData = prev.keratomentryData;
        let originalData = JSON.parse(prev.dupKeratomentryData);

        switch (key) {
          case 'miresNotRE':
            return {
              ...prev,
              miresNotRE: value,
              keratomentryData: value ? updatedKeratomentryData?.map((item) =>
                item.eye_type === 'RE'
                  ? { ...item, k1_value: '', k2_value: '', average_value: '', cylindrical_value: '' }
                  : item
              ) : updatedKeratomentryData?.map(item => item?.eye_type === 'RE' ? item : item)
    }
          case 'miresNotLE':
return {
  ...prev,
  miresNotLE: value,
  keratomentryData: value ? updatedKeratomentryData?.map((item) =>
    item.eye_type === 'LE'
      ? { ...item, k1_value: '', k2_value: '', average_value: '', cylindrical_value: '' }
      : item
  ) : updatedKeratomentryData?.map(item => item?.eye_type === 'LE' ? item : item)

}
        }
      })
    } catch (error) {
  errorMessage(error.message)
}
  }

return (
  <ShowComponents onIntersection={apicalls}>
    <Box component={'div'}>
      <Accordion expanded={props.accordionOpen}
        onChange={(_, isExpanded) => {
          props.setAccordionOpen(isExpanded, true);
        }}>
        <AccordionSummary className='doc_notes_header_card' expandIcon={<ExpandMoreIcon />}>
        <Box component={'div'} className='doc_notes_header_card' width={"100%"}>
          <Typography className='doc_notes_header_card_font'>Keratometry</Typography>
          <Box component={'div'} display={'flex'} alignItems={'center'}>
            <Tooltip placement='top' arrow title={'Copy'}><IconButton className='Common_Btn_Min_Width'
              disabled={!kerato.enableCopy || props?.props?.patient_transfered || props?.props?.isLocked}
              onClick={() => setKerato((prev) => ({
                ...prev, 
                keratomentryData: kerato.prevKeratomentryData
            }))}
            >{<ContentCopyIcon color={!kerato.enableCopy ? '' : 'primary'} />}</IconButton></Tooltip>
            <Tooltip placement='top' arrow title={'View'}><IconButton className='Common_Btn_Min_Width'
              disabled={!(kerato.enableCompare && kerato.enableCopy) || props?.props?.patient_transfered || props?.props?.isLocked}
              onClick={(e) => {
                e.stopPropagation();
                setKerato((prev) => ({ ...prev, openComparePopup: true }))}}
            ><VisibilityIcon color={!(kerato.enableCompare && kerato.enableCopy) ? '' : 'primary'} /></IconButton></Tooltip>
          </Box>
        </Box>
        </AccordionSummary>
        <AccordionDetails component={'div'} p={'0.5rem'}>
          {renderKeratoTable()}
          <Box component={'div'} mt={'0.5rem'}>
            <FormGroup row>
              <FormControlLabel control={<Checkbox disabled={props?.props?.patient_transfered || props?.props?.isLocked} checked={kerato.miresNotRE} onChange={(e) => onChangeCheckboxHandler(e, 'miresNotRE')} />} label="Mires Not Clear (RE)" />
              <FormControlLabel control={<Checkbox disabled={props?.props?.patient_transfered || props?.props?.isLocked} checked={kerato.miresNotLE} onChange={(e) => onChangeCheckboxHandler(e, 'miresNotLE')} />} label="Mires Not Clear (LE)" />
            </FormGroup>
          </Box>
          <Box component={'div'} mt={'0.5rem'}>
            <Typography className='doc_notes_header_card_font'>Comments</Typography>
            <TextField
              disabled={props?.props?.patient_transfered || props?.props?.isLocked}
              size='small'
              fullWidth
              multiline
              rows={10}
              value={kerato.keratoComments}
              onChange={(e) => {
                let value = e.target.value
                if (value?.length <= COMMON_STYLE.CHAR_LIMIT_DESP || value === '') {
                  setKerato((prev) => ({ ...prev, keratoComments: value }))
                }
              }}
              placeholder='Enter Comments'
              InputProps={{ emed_tid: 'ket_cmts' }}
            />
          </Box>
        </AccordionDetails>
      </Accordion>
      {renderComparePopup()}
      {message.isErrorMsg ?
        <ToastMsg
          severity={'error'}
          msg={message.isErrorMsgText}
          msgPop={msgClose}
        />
        : null}
      {message.successMsg ?
        <ToastMsg
          severity={'success'}
          msg={message.successMsgText}
          msgPop={msgClose}
        />
        : null}
    </Box>
  </ShowComponents>
)
})

export default UmaKeratometry